// Hideo - Italian translations: PED (formats, the video dialog, calendar, timeline, agenda, the .ics file).
// Keys are the English source strings used in the code (see docs/i18n.md).
import type { Dictionary } from '../types'

const it: Dictionary = {
    'Type': 'Tipo',
    'All': 'Tutti',
    'Format': 'Format',
    'No format': 'Senza format',
    'New format': 'Nuovo format',
    'in project': 'nel progetto',
    'Format name': 'Nome del format',
    'Create': 'Crea',
    'None': 'Nessuno',
    'Delete the format "{name}"?': 'Eliminare il format "{name}"?',
    '{n} of {total}': '{n} di {total}',
    'Open external script link': 'Apri link script esterno',
    'Open script · {title}': 'Apri script · {title}',
    'Type and status, in the words of the Type': 'Tipo e stato con le parole del Tipo',
    'Trial Reel': 'Reel di Prova',
    'Voice note': 'Vocale',
    'The end of work (publish day) has passed and the video is not ready': 'La fine lavoro (giorno di pubblicazione) è passata e il video non è pronto',
    'Overdue': 'In ritardo',
    'Removes the video from the Board and moves it to Published videos': 'Toglie il video dalla Board e lo mette in Video pubblicati',
    'Mark as published': 'Segna come pubblicato',
    'No videos': 'Nessun video',
    'New video in this column': 'Nuovo video in questa colonna',
    'Untitled': 'Senza Titolo',
    'High': 'Alta',
    'Medium': 'Media',
    // Look of the Timeline bars and Calendar cards (CardLookBar.vue)
    'Small': 'Piccola',
    'Large': 'Grande',
    'Size': 'Dimensione',
    'Size: {size}': 'Dimensione: {size}',
    'On the left': 'A sinistra',
    'No image': 'Nessuna immagine',
    'Image: {mode}': 'Immagine: {mode}',
    'Low': 'Bassa',
    'VOICE NOTE': 'VOCALE',
    'Remove the voice note from the video': 'Togli il vocale dal video',
    'To transcribe it, play it and dictate the text into the Notes with the microphone of your phone keyboard.': 'Per trascriverlo, ascoltalo e detta il testo negli Appunti con il microfono della tastiera del telefono.',
    'Remove the voice note from this video? (applies when you save)': 'Togliere il vocale da questo video? (si applica quando salvi)',
    'Remove': 'Togli',
    'Horizontal': 'Orizzontale',
    'Long horizontal video: script, 16:9 thumbnail and SEO for YouTube.': 'Video lungo orizzontale: script, miniatura 16:9 e SEO per YouTube.',
    'Horizontal video: the second tab has the SEO for YouTube (title, description, chapters, tags).': 'Video orizzontale: nella seconda scheda trovi la SEO per YouTube (titolo, descrizione, capitoli, tag).',
    'The video': 'Il video',
    'Script and notes': 'Script e appunti',
    'SCRIPT': 'SCRIPT',
    'Add thumbnail (optional)': 'Aggiungi miniatura (opzionale)',
    'End of work · publishing (day and time)': 'Fine lavoro · pubblicazione (giorno e ora)',
    'Last step: SEO': 'Ultimo passo: la SEO',
    'Got everything in? Optimise the title, description, chapters and tags for YouTube.': 'Hai inserito tutto? Ottimizza titolo, descrizione, capitoli e tag per YouTube.',
    'Vertical': 'Verticale',
    'Shorts, Reels and TikTok: 9:16 cover, hook, length and caption.': 'Short, Reel e TikTok: copertina 9:16, gancio, durata e didascalia.',
    'Vertical video (Short, Reel, TikTok): 9:16 cover and, in the second tab, hook, length and caption.': 'Video verticale (Short, Reel, TikTok): copertina 9:16 e, nella seconda scheda, gancio, durata e didascalia.',
    'The Short': 'Lo Short',
    'Vertical 9:16 cover (optional)': 'Copertina verticale 9:16 (opzionale)',
    'Last step: publishing': 'Ultimo passo: la pubblicazione',
    'Check hook and length, write the title and caption to copy to Shorts, TikTok and Instagram.': 'Controlla gancio e durata, scrivi titolo e didascalia da copiare su Shorts, TikTok e Instagram.',
    'Image': 'Immagine',
    'Photo or carousel: image and caption, no script.': 'Foto o carosello: immagine e didascalia, niente script.',
    'Post (photo or carousel): no script; write the caption in the second tab.': 'Post (foto o carosello): niente script; nella seconda scheda scrivi la didascalia.',
    'The post': 'Il post',
    'Notes': 'Appunti',
    'Post image or first slide (optional)': 'Immagine del post o prima slide (opzionale)',
    'Last step: the caption': 'Ultimo passo: la didascalia',
    'Write the caption with the keyword in the first line and copy it.': 'Scrivi la didascalia con la parola chiave nella prima riga e copiala.',
    'Live stream': 'Diretta',
    'Live stream: a run sheet instead of the script, time, title and description.': 'Diretta: scaletta al posto dello script, orario, titolo e descrizione.',
    'Live stream: a run sheet instead of the script; title, description, thumbnail and time in the second tab.': 'Diretta: al posto dello script una scaletta; nella seconda scheda titolo, descrizione, miniatura e orario.',
    'The live stream': 'La diretta',
    'Run sheet and notes': 'Scaletta e appunti',
    'RUN SHEET': 'SCALETTA',
    'Live stream thumbnail (optional)': 'Miniatura della diretta (opzionale)',
    'Start of the live stream (day and time)': 'Inizio della diretta (giorno e ora)',
    'Last step: the announcement': 'Ultimo passo: l\'annuncio',
    'Title, description, thumbnail and time of the live stream.': 'Titolo, descrizione, miniatura e orario della diretta.',
    'Article': 'Articolo',
    'Article written in the editor: cover, reading time and SEO for the web.': 'Articolo scritto nell\'editor: copertina, tempo di lettura e SEO per il web.',
    'Blog: write the article in the editor; the SEO for Google (title, description, address) is in the second tab.': 'Blog: scrivi l\'articolo nell\'editor; nella seconda scheda la SEO per Google (titolo, descrizione, indirizzo).',
    'The article': 'L\'articolo',
    'Article and notes': 'Articolo e appunti',
    'ARTICLE': 'ARTICOLO',
    'Cover image (optional)': 'Immagine di copertina (opzionale)',
    'Last step: SEO for the web': 'Ultimo passo: la SEO per il web',
    'Title for Google, meta description, address and alternative text of the cover.': 'Titolo per Google, meta descrizione, indirizzo e testo alternativo della copertina.',
    'Edit Video': 'Modifica Video',
    'The script "{title}" is not linked to any video (the video was not saved).\n\nIf you keep it, you can find it by opening a video › Create script › "Script without video".': 'Lo script "{title}" non è collegato a nessun video (il video non è stato salvato).\n\nSe lo tieni, lo ritrovi aprendo un video › Crea script › "Script senza video".',
    'Script without video': 'Script senza video',
    'Delete the script': 'Elimina lo script',
    'Keep it': 'Tienilo',
    'Keep them': 'Tienili',
    'Enter at least the video title!': 'Inserisci almeno il titolo del video!',
    'The work start must come before the end of work (publish day and time).': 'L\'inizio lavoro deve venire prima della fine lavoro (giorno e ora di pubblicazione).',
    '"{title}" is in Published videos': '"{title}" è nei Video pubblicati',
    '"{title}" is back in the plan': '"{title}" è tornato nel PED',
    'Video ready to publish!': 'Video pronto da pubblicare!',
    'Video added to the plan': 'Video aggiunto al PED',
    'Are you sure you want to delete this video?': 'Sei sicuro di voler eliminare questo video?',
    'Also delete the script of this video?\n\nIf you keep it, you can find it by opening another video › Create script › "Script without video".': 'Eliminare anche lo script di questo video?\n\nSe lo tieni, lo ritrovi aprendo un altro video › Crea script › "Script senza video".',
    'Also delete the {n} scripts of this video?\n\nIf you keep them, you can find them by opening another video › Create script › "Script without video".': 'Eliminare anche gli {n} script di questo video?\n\nSe li tieni, li ritrovi aprendo un altro video › Crea script › "Script senza video".',
    'Month': 'Mese',
    'Week': 'Settimana',
    'All videos have a date': 'Tutti i video hanno una data',
    'No date: drag them onto a day to schedule them': 'Senza data: trascinali su un giorno per programmarli',
    'New video on this day': 'Nuovo video in questo giorno',
    'no<br>time': 'senza<br>orario',
    '{n} video without an end of work (publish date)': '{n} video senza fine lavoro (data di pubblicazione)',
    '{n} videos without an end of work (publish date)': '{n} video senza fine lavoro (data di pubblicazione)',
    '+1 more': '+1 altro',
    '+{n} more': '+{n} altri',
    'less than an hour': 'meno di un\'ora',
    '{n} hour': '{n} ora',
    '{n} hours': '{n} ore',
    '{n} day': '{n} giorno',
    '{n} days': '{n} giorni',
    '{n} video in this period': '{n} video in questo periodo',
    '{n} videos in this period': '{n} video in questo periodo',
    '{n} in other periods': '{n} in altri periodi',
    '{n} without an end of work': '{n} senza fine lavoro',
    '{n} overdue': '{n} in ritardo',
    'No end of work: open the video and choose the dates': 'Senza fine lavoro: apri il video e scegli le date',
    'No end of work: drag them onto a point of the timeline, or open the video and choose the dates': 'Senza fine lavoro: trascinali su un punto della timeline, oppure apri il video e scegli le date',
    'End of work {date} · start not chosen': 'Fine lavoro {date} · inizio non scelto',
    'Overdue by {time}': 'In ritardo di {time}',
    'Delivered {date}, {time} after the end of work': 'Consegnato {date}, {time} dopo la fine lavoro',
    'Delivered {date}, on time': 'Consegnato {date}, in tempo',
    'Delivered late': 'Consegnato in ritardo',
    'Delivered on time': 'Consegnato in tempo',
    'Start not chosen': 'Inizio non scelto',
    'Drag to choose the start': 'Trascina per scegliere l\'inizio',
    'Change the start': 'Cambia l\'inizio',
    'Change the end of work (publication)': 'Cambia la fine lavoro (pubblicazione)',
    'Other statuses': 'Altri stati',
    'Drag a video without dates here': 'Trascina qui un video senza date',
    'No videos in progress in this period.': 'Nessun video in lavorazione in questo periodo.',
    'Open a video and choose "Work start" and "End of work": it will appear here as a bar.': 'Apri un video e scegli "Inizio lavoro" e "Fine lavoro": comparirà qui come una barra.',
    'End of work: {date}': 'Fine lavoro: {date}',
    'The end of work is before the start': 'La fine lavoro è prima dell\'inizio',
    'Delivered {date}: <b class="text-brand">{time} after the end of work</b>': 'Consegnato {date}: <b class="text-brand">{time} dopo la fine lavoro</b>',
    'Delivered {date}: on time': 'Consegnato {date}: in tempo',
    'When you save, it is marked as delivered now: <b class="text-brand">{time} after the end of work</b>': 'Quando salvi viene segnato come consegnato adesso: <b class="text-brand">{time} dopo la fine lavoro</b>',
    'When you save, it is marked as delivered now, on time': 'Quando salvi viene segnato come consegnato adesso, in tempo',
    '<b class="text-brand">Overdue by {time}</b>. When it is ready move it to "Ready/Published", or move the end of work.': '<b class="text-brand">In ritardo di {time}</b>. Quando è pronto spostalo in "Pronto/Pubblicato", oppure sposta la fine lavoro.',
    'Work duration: {time}': 'Durata del lavoro: {time}',
    'Choose the start too, to see in the Timeline how long the work takes.': 'Scegli anche l\'inizio per vedere nella Timeline quanto dura il lavoro.',
    'The end of work is the publish day (and time): Calendar, Timeline and "To do and overdue" use it.': 'La fine lavoro è il giorno (e l\'ora) di pubblicazione: la usano Calendario, Timeline e "Da fare e in ritardo".',
    'Start the script': 'Inizia lo script',
    'Finish the script': 'Finisci lo script',
    'Record': 'Registra',
    'Finish editing': 'Finisci il montaggio',
    'Start the post': 'Inizia il post',
    'Finish text and idea': 'Finisci testo e idea',
    'Create photo or graphics': 'Crea foto o grafica',
    'Review the post': 'Rivedi il post',
    'Start the article': 'Inizia l\'articolo',
    'Finish and publish': 'Finisci e pubblica',
    'Start the run sheet': 'Inizia la scaletta',
    'Finish the run sheet': 'Finisci la scaletta',
    'Do the tech check': 'Fai le prove tecniche',
    'Announce the live stream': 'Annuncia la diretta',
    '{date} at {time}': '{date} ore {time}',
    'End of work {date}': 'Fine lavoro {date}',
    'End of work passed': 'Fine lavoro passata',
    'It was due {date} and is still "{status}"': 'Doveva essere pronto {date} ed è ancora "{status}"',
    'Checklist to complete': 'Checklist da completare',
    'Today': 'Oggi',
    // src/components/CalJump.vue
    'Go to another month or year': 'Vai a un altro mese o anno',
    'Choose the year': "Scegli l'anno",
    'Choose the decade': 'Scegli il decennio',
    'Years {span}': 'Lustro {span}',
    'Back to today': 'Torna a oggi',
    'In {n} day': 'Tra {n} giorno',
    'In {n} days': 'Tra {n} giorni',
    '{step} (suggested by {date})': '{step} (consigliato entro {date})',
    '{step} by {date}': '{step} entro {date}',
    'To do now': 'Da fare ora',
    '{text} · Missing: {items}': '{text} · Mancano: {items}',
    'To do and overdue': 'Da fare e in ritardo',
    '{n} thing to do': '{n} cosa da fare',
    '{n} things to do': '{n} cose da fare',
    'The plan starts from the end of work of each video': 'Il piano parte dalla fine lavoro di ogni video',
    'Put releases and deadlines in your phone calendar, with reminders': 'Metti le uscite e le scadenze nel calendario del telefono, con i promemoria',
    'In the calendar': 'Nel calendario',
    'All caught up.': 'Tutto in pari.',
    'No end of work in the next 7 days: give a video a date from the plan, the Calendar or the Timeline.': 'Nessuna fine lavoro nei prossimi 7 giorni: dai una data a un video dal PED, dal Calendario o dalla Timeline.',
    'Show less': 'Mostra meno',
    'Show all ({n})': 'Mostra tutte ({n})',
    'Suggested deadlines: the end of work is the publish day. If the video also has a work start, the plan runs from start to end; otherwise script started 7 days before the end, finished 5 days before, recording 3 days before, editing finished the day before.': 'Scadenze consigliate: la fine lavoro è il giorno di pubblicazione. Se il video ha anche l\'inizio lavoro, il piano va dall\'inizio alla fine; altrimenti script iniziato 7 giorni prima della fine, finito 5 giorni prima, registrazione 3 giorni prima, montaggio finito il giorno prima.',
    'Status: {status}': 'Stato: {status}',
    'Type: {type}': 'Tipo: {type}',
    'From Hideo': 'Da Hideo',
    '🎬 Release: {title}': '🎬 Uscita: {title}',
    'Out tomorrow: {title}': 'Domani esce: {title}',
    'Out in an hour: {title}': 'Tra un\'ora esce: {title}',
    'Out today: {title}': 'Oggi esce: {title}',
    'Suggested deadline for the release on {date}.': 'Scadenza consigliata per l\'uscita del {date}.',
    'In your phone calendar': 'Nel calendario del telefono',
    'Releases and deadlines in your calendar, with reminders': 'Uscite e scadenze nel tuo calendario, con i promemoria',
    'Reminder the day before': 'Promemoria il giorno prima',
    'At 9:00, or 24 hours before if the video has a time': 'Alle 9, oppure 24 ore prima se il video ha un orario',
    'Reminder on release day': 'Promemoria il giorno dell\'uscita',
    'One hour before if the video has a time, otherwise at 9:00': 'Un\'ora prima se il video ha un orario, altrimenti alle 9',
    'Work deadlines too': 'Anche le scadenze di lavoro',
    'Start the script, finish the script, record, finish editing': 'Inizia lo script, finisci lo script, registra, finisci il montaggio',
    'Otherwise only the project picked at the top': 'Altrimenti solo il progetto scelto in alto',
    'Create the calendar file': 'Crea il file del calendario',
    '<b class="text-gray-200">iPhone:</b> open the downloaded file and tap "Add All".': '<b class="text-gray-200">iPhone:</b> apri il file scaricato e tocca "Aggiungi tutto".',
    '<b class="text-gray-200">Google Calendar (Android):</b> on a computer open calendar.google.com › Settings › Import & export › Import, and choose the file. The events reach your phone too.': '<b class="text-gray-200">Google Calendar (Android):</b> dal computer apri calendar.google.com › Impostazioni › Importa ed esporta › Importa, scegli il file. Gli eventi arrivano anche sul telefono.',
    '<b class="text-gray-200">When you change the dates</b> make the file again and import it again: it is a snapshot of the moment and does not update by itself. Tip: in Google create a "Hideo" calendar and import there, so you can empty it and re-import without touching the rest.': '<b class="text-gray-200">Quando cambi le date</b> rifai il file e importalo di nuovo: è una fotografia del momento, non si aggiorna da solo. Consiglio: in Google crea un calendario "Hideo" e importa lì, così puoi svuotarlo e reimportare senza toccare il resto.',
    'No video has a release date: give it one from the plan or the Calendar, then try again.': 'Nessun video ha una data di uscita: dagliela dal PED o dal Calendario, poi riprova.',
    'hideo-releases': 'hideo-uscite',
    'Hideo releases': 'Uscite di Hideo',
    // Video dialog labels (VideoDialog.vue, features/video.ts)
    'CONTENT TYPE': 'TIPO DI CONTENUTO',
    'E.g. New camera review': 'Es. Recensione nuova camera',
    'TRIAL REEL (INSTAGRAM ONLY)': 'REEL DI PROVA (SOLO INSTAGRAM)',
    'Yes': 'Sì',
    'Every video has its own scripts: start from blank, from a template, from a hook or from a .md / .txt file.': 'Ogni video ha i suoi script: parti da vuoto, da un template, da un hook o da un file .md / .txt.',
    'EXTERNAL SCRIPT LINK (OPTIONAL)': 'LINK SCRIPT ESTERNO (OPZIONALE)',
    'NOTES': 'APPUNTI',
    'Ideas, voice-note transcript, things to remember... (@ to mention). Texts to publish go in the second tab.': 'Idee, trascrizione del vocale, cose da ricordare... (@ per menzionare). I testi da pubblicare vanno nella seconda scheda.',
    'Workflow': 'Lavorazione',
    'STATUS': 'STATO',
    'PRIORITY': 'PRIORITÀ',
    'DATES': 'DATE',
    'Work start': 'Inizio lavoro',
    'Choose the day': 'Scegli il giorno',
    'Choose the day first': 'Prima scegli il giorno',
    'Previous month': 'Mese precedente',
    'Next month': 'Mese successivo',
    'Start': 'Inizio',
    'End': 'Fine',
    'No time': 'Senza orario',
    'End of work · publishing': 'Fine lavoro · pubblicazione',
    'Clear the start': "Togli l'inizio",
    'Clear the end of work': 'Togli la fine lavoro',
    '{n} min': '{n} min',
    '{n} h': '{n} h',
    '{h} h {m} min': '{h} h {m} min',
    'Go': 'Vai',
    'Save video': 'Salva video'
}

export default it
